import { render, staticRenderFns } from "./ConfigFinance.vue?vue&type=template&id=655f14f9&"
import script from "./ConfigFinance.vue?vue&type=script&lang=js&"
export * from "./ConfigFinance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports